var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 70,
    height: 70,
    rx: 21.5,
    fill: "white",
    stroke: "#56AAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5025 31.75H39.25V24.6667C39.25 23.8875 38.6125 23.25 37.8334 23.25H32.1667C31.3875 23.25 30.75 23.8875 30.75 24.6667V31.75H28.4975C27.2367 31.75 26.5992 33.28 27.4917 34.1725L33.9942 40.675C34.5467 41.2275 35.4392 41.2275 35.9917 40.675L42.4942 34.1725C43.3867 33.28 42.7634 31.75 41.5025 31.75ZM25.0834 45.9167C25.0834 46.6958 25.7209 47.3333 26.5 47.3333H43.5C44.2792 47.3333 44.9167 46.6958 44.9167 45.9167C44.9167 45.1375 44.2792 44.5 43.5 44.5H26.5C25.7209 44.5 25.0834 45.1375 25.0834 45.9167Z",
    fill: "#56AAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp);
export default __webpack_public_path__ + "static/media/App.551c749a664dc6fc6a74159d24200471.svg";
export { ForwardRef as ReactComponent };